<template>
  <div>
    <el-col>
      <h4 class="h4">
        <i class="el-icon-s-management"></i>&nbsp;&nbsp;{{ $t('preprint.submitSubmit.title') }}
      </h4>
    </el-col>

    <el-card shadow="never" style="margin: 20px">
      <div slot="header">
        <span style="font-weight: 900; color: #006a71">{{ $t('preprint.submitSubmit.confirmTitle') }}</span>
      </div>
      <el-row>
        <el-col :span="24" style="margin-bottom: 10px">
          <i class="el-icon-check" style="color: #67C23A"></i>
          {{ $t('preprint.submitSubmit.confirmInfo') }}
        </el-col>
        <el-col :span="24" style="margin-bottom: 10px">
          <i class="el-icon-check" style="color: #67C23A"></i>
          {{ $t('preprint.submitSubmit.confirmAuthor') }}
        </el-col>
        <el-col :span="24" style="margin-bottom: 10px">
          <i class="el-icon-check" style="color: #67C23A"></i>
          {{ $t('preprint.submitSubmit.confirmFile') }}
        </el-col>
      </el-row>
    </el-card>

    <el-row style="margin: 20px">
      <el-col :span="24" style="text-align: center">
        <el-button
          type="primary"
          size="large"
          @click="submitPreprint"
          :loading="submitting"
          style="background-color: #054a48; border: none; width: 200px"
        >
          {{ $t('preprint.submitSubmit.submitButton') }}
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { submitPreprint } from '@/api/preprint'

export default {
  name: 'PreprintSubmitComponent',
  data() {
    return {
      userInfo: null,
      submitting: false,
      preprintId: null,
      mode: 'new'
    }
  },
  methods: {
    submitPreprint() {
      // 获取保存的数据
      const preprintInfo = JSON.parse(sessionStorage.getItem('preprintInfo') || '{}')
      const authors = JSON.parse(sessionStorage.getItem('preprintAuthors') || '[]')
      const fileInfo = JSON.parse(sessionStorage.getItem('preprintFile') || '{}')

      // 验证数据
      if (!preprintInfo.title || !preprintInfo.preprintType || !preprintInfo.abstractText || !preprintInfo.keywords) {
        this.$message.warning(this.$t('preprint.submitSubmit.infoIncomplete'))
        return
      }

      if (!authors || authors.length === 0) {
        this.$message.warning(this.$t('preprint.submitSubmit.authorIncomplete'))
        return
      }

      if (!fileInfo.fileName || !fileInfo.filePath) {
        this.$message.warning(this.$t('preprint.submitSubmit.fileIncomplete'))
        return
      }

      // 转换作者数据格式
      const formattedAuthors = authors.map((author, index) => ({
        authorName: author.authorName,
        authorEmail: author.authorEmail,
        authorAffiliation: author.authorAffiliation,
        authorOrder: index + 1,
        isCorresponding: author.isCorresponding ? 1 : 0
      }))

      // 组装提交数据
      const submitData = {
        userInfo: {
          email: this.userInfo.email,
          name: this.userInfo.name
        },
        title: preprintInfo.title,
        abstractText: preprintInfo.abstractText,
        keywords: preprintInfo.keywords,
        preprintType: preprintInfo.preprintType,
        manuscriptFilePath: fileInfo.filePath,
        manuscriptFileName: fileInfo.fileName,
        authors: formattedAuthors
      }

      // 如果是重新提交模式，添加预印本ID
      if (this.mode === 'resubmit' && this.preprintId) {
        submitData.id = this.preprintId
      }

      this.submitting = true
      submitPreprint(submitData).then((res) => {
        if (res.data.errorCode === 0) {
          const successMsg = this.mode === 'resubmit' 
            ? '重新提交成功！等待审核' 
            : this.$t('preprint.submitSubmit.submitSuccess')
          this.$message.success(successMsg)
          // 清除缓存
          sessionStorage.removeItem('preprintInfo')
          sessionStorage.removeItem('preprintAuthors')
          sessionStorage.removeItem('preprintFile')
          // 跳转到我的预印本列表
          setTimeout(() => {
            this.$router.push({ name: 'myPreprintList' })
          }, 1500)
        } else {
          this.$message.error(res.data.errorMessage || this.$t('preprint.submitSubmit.submitFailed'))
        }
      }).catch((err) => {
        console.error(this.$t('preprint.submitSubmit.submitError'), err)
        this.$message.error(this.$t('preprint.submitSubmit.submitError'))
      }).finally(() => {
        this.submitting = false
      })
    }
  },
  mounted() {
    this.userInfo = this.$cookie.getCookie('userInfo')
    if (!this.userInfo) {
      this.$message.error(this.$t('preprint.submitSubmit.needLogin'))
      this.$router.push({ name: 'login' })
      return
    }

    // 获取路由参数
    this.preprintId = this.$route.query.preprintId
    this.mode = this.$route.query.mode || 'new'
  }
}
</script>

<style scoped>
.h4 {
  text-align: left;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/preprint/preprintSubmitComponent.vue